__turbopack_context__.v({
  "groupFields": "OrderTypeStep-module-scss-module__ta6HrW__groupFields",
  "groupSize": "OrderTypeStep-module-scss-module__ta6HrW__groupSize",
  "groupSizeLabel": "OrderTypeStep-module-scss-module__ta6HrW__groupSizeLabel",
});
